import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import asyncValidate from './asyncValidate';
import FormFieldsClientsTabsTabDischargeTermination from 'components/form-fields-clients-tabs/tab-discharge-termination/tab-discharge-termination';
class EditViewClientTabDischargeTermination extends Component {
  render() {    
    return (
      <div>
        <FormFieldsClientsTabsTabDischargeTermination 
          {...this.props}
          locked={this.props.locked}
          programSelected={this.props.programSelected}
          clientdischargedateSelected={this.props.clientdischargedateSelected}
        />
      </div>
    );
  }
}
EditViewClientTabDischargeTermination.propTypes = {
  locked: PropTypes.bool,
  programSelected: PropTypes.string,
  clientdischargedateSelected: PropTypes.string,
}
EditViewClientTabDischargeTermination = reduxForm({
  form: 'ClientEditForm', // a unique name for this form
  asyncValidate,
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(EditViewClientTabDischargeTermination);
export default EditViewClientTabDischargeTermination;